
import React, { Fragment, useEffect, useState } from 'react'
import { useForm, SubmitHandler } from "react-hook-form";
import axios from 'axios';
import config from 'config';
import { useAuth } from '../hooks/use-auth';
import Prefectures from './PrefecturesOption';
import { removeKeyWithValue } from 'utils';
import { PageTitle, FormLabel, FormSelect, FormInput, FormLabelInputWrapper, ModalForm, ModalSubmit, LoadingContainer } from 'styles/styles';
import { CircularProgress } from '@mui/material';

interface ParentDataProps {
	name: string,
	name_kana: string,
	postcode: number,
	prefecture_id: number,
	city: string,
	block: string,
	building: string,
	phone_number: string,
	display_id: string,
	cognito_username: string
	[key: string]: string | number;
}

const CompanyInfo = () => {
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);

	useEffect(() => {
		axios.get('/v0/account/factories', {
			headers: auth.authorizationHeader,
			params: { factory_id: auth.factoryId }
		})
			.then((res) => {
				reset(res.data[0]);
			})
			.catch((err) => {
				console.log(err)
			});
	}, [auth]);


	//modal
	const { reset, register, handleSubmit, watch, formState: { errors } } = useForm<ParentDataProps>();
	const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
		let alertList: any[] = [];
		const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
		requiredFields.forEach((key) => {
			if (submitData[key] === undefined || submitData[key] === '') {
				alertList.push(key)
			}
		});
		if (alertList.length) {
			let text = '';
			parentArray.forEach(item => {
				if (alertList.includes(item.field)) {
					text += `${item.title}を埋めてください。\n`;
				}
			});
			if (text !== '') {
				alert(text);
				throw new Error('必須項目が未入力です');
			}
		}
		submitData = removeKeyWithValue(submitData, '');
		const branchData = {
			name: submitData.name,
			name_kana: submitData.name_kana,
			postcode: submitData.postcode,
			prefecture_id: submitData.prefecture_id,
			city: submitData.city,
			block: submitData.block,
			building: submitData.building,
			phone_number: submitData.phone_number,
			display_id: submitData.display_id,
		}
		try {
			setIsSubmitDisable(true);
			await axios.patch(`/v0/account/factories`, branchData, {
				headers: auth.authorizationHeader,
				params: { factory_id: auth.factoryId }
			})
			window.alert("工場情報の更新が完了しました")
		} catch (error: any) {
			window.alert(error.response.data.error);
		}
		setIsSubmitDisable(false);

	};
	//modal end

	//arrayの生成
	const parentArray = [{ title: '工場ID', field: 'display_id', type: 'text' },
	{ title: '工場の名前', field: 'name', type: 'text', required: true },
	{ title: '工場の名前（カナ）', field: 'name_kana', type: 'text' },
	{ title: '郵便番号', field: 'postcode', type: 'number' },
	{ title: '都道府県', field: 'prefecture_id', type: 'number', select: 'prefecture' },
	{ title: '市区町村', field: 'city', type: 'text' },
	{ title: '番地', field: 'block', type: 'text' },
	{ title: '建物名以下', field: 'building', type: 'text' },
	{ title: '電話番号', field: 'phone_number', type: 'tel' },
	{ title: '共有コード', field: 'share_code', disable: true }]

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						{element.select === "prefecture" ?
							<FormSelect {...register("prefecture_id")}>
								<option hidden value={""}>都道府県を選択してください</option>
								{Prefectures.map((prefecture) => (
									<option key={prefecture.code} value={prefecture.code}>
										{prefecture.name}
									</option>
								))}
							</FormSelect> :
							<FormInput {...register(element.field)}
								{...(element.type && { type: config.inputErrorMessage[element.type].type })}
								{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
								{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
								{...(element.type && { title: config.inputErrorMessage[element.type].title })}
								{...(element.required && { required: true })}
								{...(element.disable && { disabled: true })}
								{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
								{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
								{...(element.field.includes("postcode") && { max: 9999999 })}
							/>}
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});

	return (
		<>
			<PageTitle>工場情報</PageTitle>
			<ModalForm onSubmit={handleSubmit(onSubmit)}>
				{listItems}
				{isSubmitDisable ? (
					<LoadingContainer>
						<CircularProgress size={20} />
					</LoadingContainer>
				) : (
					<ModalSubmit type="submit" disabled={isSubmitDisable} />
				)}
			</ModalForm>
		</>
	)
}
export default CompanyInfo;